import moment from "moment";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import Modal from '@mui/material/Modal';
import { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import FolderIcon from '@mui/icons-material/Folder';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";

import { AppMode } from "../../../env";
import 'react-circular-progressbar/dist/styles.css';
import { toggleModal } from "../../../reducers/modalReducer";
import UserAdCard from "../../../components/card/sidebar/UserAdCard";
import { postRequest, getRequest } from "../../../config";
import { KeyboardArrowDown, KeyboardArrowUp, LockOutlined } from "@mui/icons-material";
import IndirectCompanyUserAdCard from "../../../components/card/sidebar/IndirectCompanyUserAdCard";
import ReferOffer from "../../../components/card/sidebar/ReferOffer";
import ReferCfoOfferModal from "../../../components/modals/ReferCfoOfferModal";
import CompanyReferOffer from "../../../components/card/sidebar/CompanyReferOffer";
import CompanyReferCfoOfferModal from "../../../components/modals/CompanyReferCfoOfferModal";
import { shouldShowBusinessCard, showReferCard } from "../../../utils";

export default function SidebarIndex({ visibleSection = '', isManualAdd, getUser, isWorkflowReport, setIsWorkflowReport, company, advisors, permissionLevel, setCompany, tab, setTab, sanitiseTab, toggleReport, handleSuperflowNext, setCompanyDashboardTab, getCompletenessAndRiskHTML, isExternalPage,
	setSection, getViewableURL, isViewTwoMinuteReport, twoMinuteTestAIReport, isTwoMinuteTesHomePage, setOpenTabs, openTabs, sortSections, handlePartnerChecklistNext, handleCompleteInvestmentReadiness, updateUserType, setTabName, closeTab, isBackFitReport, setIsBackFitReport, isLoader, setIsLoader }) {

	let navigate = useNavigate();
	let dispatch = useDispatch();
	let user = useSelector(state => state.user);
	let modal = useSelector(state => state.modal);
	let companies = useSelector((state) => state.companies);

	let [folderNo, setFolderNo] = useState('');
	let [folderName, setFolderName] = useState('');
	let [folderFiles, setFolderFiles] = useState([]);
	let [activePoint, setActivePoint] = useState('');
	let [sectionExpand, setSectionExpand] = useState({});
	let [sidebarFixed, setSidebarFixed] = useState(false);
	let [allocatedAdvisor, setAllocatedAdvisor] = useState({});
	let [allSectionsExpand, setAllSectionsExpand] = useState(false);
	let [isDemoPartnerChecklist, setIsDemoPartnerChecklist] = useState(false);
	let coreInfoResearchAid = {
		'marketOpportunity': { name: 'Market Opportunity', path: 'S1 Q1 & S1 Q2', sectionNo: '', notUploaded: false, uploaded: false },
		'routeToMarket': { name: 'Route to Market', path: 'S1 Q1', sectionNo: '', notUploaded: false, uploaded: false },
		'competitorAnalysis': { name: 'Competitor Analysis', path: 'S5 Q1 & S5 Q5', sectionNo: '', notUploaded: false, uploaded: false },
		'technologyAdvantage': { name: 'Technology Advantage', path: 'S4 Q1 & S4 Q4', sectionNo: '', notUploaded: false, uploaded: false },
	};

	const handleScroll = (scrollTo) => {
		const targetElement = document.getElementById(scrollTo);
		if (targetElement) {
			targetElement.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	};

	useEffect(() => {
		if (localStorage.getItem('isDemoChecklist') || localStorage.getItem('isPartnerChecklist')) setIsDemoPartnerChecklist(true);
		else setIsDemoPartnerChecklist(false);

		let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		const handleSidebarStick = () => {
			if (isSafari && window.scrollY > 925) setSidebarFixed(true);
			else setSidebarFixed(false);
		};

		window.addEventListener('scroll', handleSidebarStick);
		return () => window.removeEventListener('scroll', handleSidebarStick);
	}, []);

	useEffect(() => {
		if (tab === 'repository') setActivePoint(company?.modules?.[tab]?.sections?.[1]?.sectionNo)
		else {
			if (tab.includes('-report')) tab = tab.replace(/-report$/, "")
			setActivePoint(company?.modules?.[tab]?.sections?.[0]?.sectionNo)
		}
	}, [tab]);

	//Get company by Id
	const getCompanyById = async (companyId) => {
		if (companyId) {
			const res = await getRequest(`/company/get/company-data/${companyId}`);
			window.open(res['body']?.cWebsite, "_blank")
		}
	};

	const getAllocatedAdvisorId = (data, activePoint) => {
		if (data) {
			for (let [key, value] of Object.entries(data)) {
				if (value.modules && value.modules[activePoint] === true) {
					return key;
				}
			}
			return null;
		}
	};

	useEffect(() => {
		const advisorId = getAllocatedAdvisorId(company?.revenuelead, activePoint)
		if (advisorId) {
			setAllocatedAdvisor({
				...company?.advisorData?.find((obj, i, arr) => obj?._id === advisorId),
				sectionName: getSectionName(company, activePoint) ?? tab
			})
		}
		else {
			setAllocatedAdvisor({
				...company?.advisorData?.find((obj, i, arr) => !obj?.createdBy),
				sectionName: getSectionName(company, activePoint) ?? tab
			})
		}

	}, [activePoint]);

	useEffect(() => {
		const advisorId = getAllocatedAdvisorId(company?.revenuelead, visibleSection)
		if (advisorId) setAllocatedAdvisor({ ...company?.advisorData?.find((obj, i, arr) => obj?._id === advisorId), sectionName: getSectionName(company, visibleSection) ?? tab })
		else setAllocatedAdvisor({ ...company?.advisorData?.find((obj, i, arr) => !obj?.createdBy), sectionName: getSectionName(company, visibleSection) ?? tab })
	}, [visibleSection]);

	const truncateText = (text, maxLength) => {
		if (!text || text.length <= maxLength) {
			return text;
		}
		return text.substring(0, maxLength) + '...';
	};

	const getSectionName = (data, sectionNo) => {
		let moduleName = null;
		for (const moduleKey in data?.modules) {
			const module = data?.modules[moduleKey];
			// Check if module has sections before trying to access them
			if (module?.sections) {
				const matchingSection = module.sections.find(section => section.sectionNo === sectionNo);
				if (matchingSection) {
					moduleName = matchingSection.sectionName;
					break;
				}
			}
		}
		if (moduleName) {
			return moduleName
		}
		else {
			return "N/A"
		}
	};

	const onCardLog = async (company, user, allocatedAdvisor, clickedOn, adsData) => {
		let response = await postRequest(`/log/card/log`, {
			firmId: allocatedAdvisor?.companyId,
			advisor: allocatedAdvisor,
			hasBusinessCard: true,
			routeName: location.pathname,
			clickedOn: clickedOn,
			company: company,
			...(adsData && adsData?.adId ? { adId: adsData?.adId } : {}),
			...(adsData && adsData?.visibleSection ? { sectionNo: adsData?.visibleSection.includes('.') ? adsData?.visibleSection.split('.')[0] : adsData?.visibleSection } : {}),
			...((adsData && adsData?.isDefault) && { isDefault: adsData?.isDefault })
		});
	};

	const LiButton = ({ link, company, user, allocatedAdvisor, withoutLog }) => {
		return <div
			style={{
				borderRadius: "2.5rem", padding: "0px 12px", color: "#ffffff", fontSize: "12px", fontWeight: "700", lineHeight: "1rem", cursor: link ? "pointer" : 'text',
				background: link ? "linear-gradient(120.13deg, #4A67FF -3.15%, #3956F0 8.51%, #798EFF 71.07%, #8496F4 102.88%)" : '#999',
			}}
			onClick={() => {
				if (link) window.open(link.startsWith("https://") ? link : `https://${link}`, '_blank')
				if (withoutLog === false) onCardLog(company, user, allocatedAdvisor, "linkedIn")
			}}
		><img src={require('../../../../images/landingpage/linkedin-logo.svg')} alt='Linkedin Logo' style={{ height: '10px' }} />
		</div>
	};

	const getFilesFromQuestions = (questions) => questions && questions.filter(q => q.answer?.files?.length)
		.reduce((arr, q) => [...arr, ...q.answer.files.map(file => ({
			...file,
			questionId: q._id,
			questionNo: q.qNo,
			answerId: q.answer._id,
			drLastSync: q?.answer?.drLastSync ? q?.answer?.drLastSync : '',
			dbLastSync: q?.answer?.dbLastSync ? q?.answer?.dbLastSync : '',
			title: file.originalname,
			url: file.location,
			ext: file.originalname.split(".").slice(-1)[0],
		}))], []);

	const toggleSectionExpand = (sectionId) => setSectionExpand(prevState => ({ ...prevState, [sectionId]: !prevState[sectionId] }));
	const toggleAllSectionsExpand = () => setAllSectionsExpand(!allSectionsExpand);
	const handleReport = async (e, module) => {
		if (user['role'] == 'Investor' && user?.['companyId']?.['_id'] && isBackFitReport) {
			window.location.href = `/company/${company['_id']}#fit-report:${user?.['companyId']?.['_id']}`;
			setIsBackFitReport(false);
			setTab(`fit-report:${user?.['companyId']?.['_id']}`);
			setOpenTabs(new Set([`fit-report:${user?.['companyId']?.['_id']}`]));
			return;
		};
		if ((localStorage.getItem('isDiligencePack') && !isBackFitReport) || user?.['type'] == 'External') {
			window.location.href = `/company/${company['_id']}#diligence-pack`;
			setTab('diligence-pack');
			setOpenTabs(new Set([`diligence-pack`]));
			localStorage.removeItem('isDiligencePack');
			return;
		};

		if (user['role'] == 'User' && isBackFitReport) {
			setIsBackFitReport(false);
			setTabName('');
			setCompanyDashboardTab('InvestorMatch')
			return;
		};

		if (isWorkflowReport) setIsWorkflowReport(false);

		let isDiligenceReport = localStorage.getItem('isDiligenceReport');
		if (isDiligenceReport) {
			// close all tabs
			Array.from(openTabs).map(async openTab => {
				await openTabs.delete(openTab);
				setOpenTabs(new Set(Array.from(openTabs)));
			});

			let redirectTab = (location.href.split('#')[1]);
			setTab(redirectTab);
			return;
		}

		if (tab.includes('two-minute-test') && !tab.endsWith("-report")) twoMinuteTestAIReport(module);
		else if (tab.includes('investor-lead')) {
			window.history.replaceState(null, '', window.location.pathname);
			setCompanyDashboardTab('InvestorMatch')
			setTabName('')
			closeTab(e, tab)
		}
		else toggleReport(e);
	};

	const showSection = (section, sectionFiles, subSection) => {
		return <>
			{isTwoMinuteTesHomePage ? (
				<button className="df fww w100 cna" style={{ width: '96%', padding: '5px 0px 0px 7px' }} disabled>
					<span className={"fw500 w70 asc pen uss ass tal pr1-5rem"}>{`${subSection?.no} ${subSection?.name}`} </span>
					{sectionFiles && sectionFiles.filter(file => file.questionNo === subSection?.no)?.length > 0 &&
						<button className="pa r0 cp mr0-5rem" style={{ background: "transparent" }}
							onClick={() => {
								setSection(section);
								setFolderNo(subSection?.no);
								setFolderName(subSection?.name);
								setFolderFiles(sectionFiles && sectionFiles.filter(file => file.questionNo === subSection?.no));
								dispatch(toggleModal({ open: 'manageIndexFiles' }));
							}}>
							<FolderIcon className={`pa r0 fs2rem w10 h10 t50 ${sectionFiles.filter(file => file.questionNo === subSection?.no)?.length > 0 ? 'c10' : 'c12'}`} />
							<div className="pa qNoSidebar c1 fs0-5rem fw600" style={{ top: '8px', userSelect: 'none', }}>
								{sectionFiles && sectionFiles.filter(file => file.questionNo === subSection?.no)?.length > 0 &&
									sectionFiles.filter(file => file.questionNo === subSection?.no)?.length
								}
							</div>
						</button>
					}
				</button>
			) : (
				<div data-scroll-to={subSection?.no} onClick={() => handleScroll(subSection?.no)} className="df fww w100" style={{ width: '96%', padding: '5px 0px 0px 7px', background: subSection?.stats?.completionPercent > 0 ? '#bbeadb' : 'transparent' }}>
					<span className={"fw500 w70 asc pen uss ass tal pr1-5rem c2 c6-hover"}>{`${subSection?.no} ${subSection?.name}`} </span>
					{subSection?.['updatedAt'] &&
						<div className="w100 df jcc tac cp c2 c6-hover" style={{ fontSize: "10px" }}>Last Updated: {moment(subSection?.['updatedAt']).format('DD/MMM/YY')}</div>
					}
					{sectionFiles && sectionFiles.filter(file => file.questionNo === subSection?.no)?.length > 0 &&
						<button className="pa r0 cp mr0-5rem" style={{ background: "transparent" }}
							onClick={() => {
								setSection(section);
								setFolderNo(subSection?.no);
								setFolderName(subSection?.name);
								setFolderFiles(sectionFiles && sectionFiles.filter(file => file.questionNo === subSection?.no));
								dispatch(toggleModal({ open: 'manageIndexFiles' }));
							}}>
							<FolderIcon className={`pa r0 fs2rem w10 h10 t50 ${sectionFiles.filter(file => file.questionNo === subSection?.no)?.length > 0 ? 'c10' : 'c12'}`} />
							<div className="pa qNoSidebar c1 fs0-5rem fw600" style={{ top: '8px', userSelect: 'none', }}>
								{sectionFiles && sectionFiles.filter(file => file.questionNo === subSection?.no)?.length > 0 &&
									sectionFiles.filter(file => file.questionNo === subSection?.no)?.length
								}
							</div>
						</button>
					}
				</div>
			)}
		</>
	};

	function getSectionUpdatedAt(company, section) {
		// Case 1: No questions
		if (!section.questions || section.questions.length === 0) {
			return company.updatedAt;
		}

		// Collect all answer.updatedAt values
		const answerDates = section.questions
			.map(q => q.answer?.updatedAt)   // answer exist kare to uska updatedAt
			.filter(Boolean);                // null/undefined remove kar do

		// Case 2: If no answers available in any question
		if (answerDates.length === 0) {
			return company.updatedAt;
		}

		// Case 3: Return the latest answer.updatedAt
		return answerDates.reduce((latest, date) => {
			return new Date(date) > new Date(latest) ? date : latest;
		});
	}

	const getSidebarHTML = (module, showInTooltip = false) => {
		let array = [];
		let isViewWorkflow = false;
		if (module?.['category']) isViewWorkflow = true;
		// if (module) calculateStats(company, tab, "check1");
		if (module && module.sections && module?.['expansionPack']) array = Object.values(module['sections'][0]['subFolders']);
		else array = module?.sections;

		if (array?.length > 0) for (let i = 0; i < array.length; i++) {
			if (array[i].type == "Additional Sections" && (array[i].sectionName === '')) {
				array.splice(i, 1);
				i -= 1;
			}
		}

		const style = showInTooltip ? {} : { width: "calc((100% - 4rem) / 5)" };
		const jsx = module && module.sections && (
			<div id="sidebar" style={style} className={(showInTooltip ? "" : (tab == 'esg' || tab == 'business-audit' || tab.includes("two-minute-test")) ? "esg-sidebar " : "h100vh ") + (tab && tab.match(/directors-questionnaire/) && " questionnaire-sidebar ") + (module.type === 'repository' && " repository-sidebar ") + ` w100 bsbb dg gg1rem t0 sidebar-report ${sidebarFixed ? 'sidebar-fixed' : 'ps'}`}>
				{isManualAdd
					? <><img src={require('../../../../images/investor-manual-add/applicant-info-ai.png')} alt="inteligent-girl" /></>
					: <div className="bo45 bss bw1px br8px bg38">
						{!showInTooltip &&
							<div className="df jcc aic fdc p0-5rem">
								<h3 className="c3 fs1-25rem ttu w100 tac">
									{tab == 'investor-lead' || module?.['heading'] == 'Investor Match' || module?.['type'] == 'investor-lead'
										? <span className="c15">Investor<span className="c4">Match</span></span>
										: module?.['heading'] ? module?.['heading'] : module?.['type'].includes('directors-questionnaire') ? 'Directors Questionnaire' : module?.['type'] || company.modules[sanitiseTab(tab)]?.['heading'] + " Report"
									}
								</h3>
								<h4 className="c3 ttu lh1 fs1-25rem mt0-5rem tac pr w100"> Index
									{module['type'] === 'repository' && <Link to="https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository" target="_blank" className="help-icon pa cp">
										<i className="icon"><img className="question-button" src={require(`../../../../images/pink-question.svg`)} alt="" /></i>
									</Link>}
								</h4>
								{((permissionLevel == "ALL" || permissionLevel == "DASHBOARD & REPORT") && user?.['type'] !== 'Superflow') && <>
									{tab.includes("kpi-report") && isViewTwoMinuteReport
										? <img className="" src={require(`../../../../images/kpiSidebar.png`)} />
										: <button disabled={isDemoPartnerChecklist} onClick={(e) => handleReport(e, module)} className={`${(!isDemoPartnerChecklist && module?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} mt1rem mxa ${isDemoPartnerChecklist ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br50px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac ${tab.endsWith("-report") && 'close-report'}`} data-tooltip={isDemoPartnerChecklist ? 'You must register to access it' : ''}>
											<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem close-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
												<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
											</svg>
											{tab == 'investor-lead'
												? 'Investor Leads'
												: <>
													{tab.endsWith("-report") ? <>{(isViewWorkflow && isWorkflowReport) ? "Close Workflow" : 'Close'}</> : "View"}
													{tab == 'warranty-disclosure' ? ' Disclosure Schedule' : ' Report'}</>
											}
										</button>
									}
									{(isViewWorkflow && !isWorkflowReport && !tab.endsWith("-report")) &&
										<button disabled={isDemoPartnerChecklist} onClick={async (e) => { await setIsWorkflowReport(true); handleReport(e, module) }} className={`${(!isDemoPartnerChecklist && module?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} mt1rem mxa ${isDemoPartnerChecklist ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br50px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac ${tab.endsWith("-report") && 'close-report'}`} data-tooltip={isDemoPartnerChecklist ? 'You must register to access it' : ''}>
											<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem close-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
												<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
											</svg>
											View Workflow Report
										</button>
									}
								</>}
								{tab.endsWith("-report") && <>
									<button disabled={(isDemoPartnerChecklist || user['role'] == 'Guest') && user['type'] !== 'External'} onClick={() => downloadPDF()} className={`h100 my0-5rem mxa shadow ${((isDemoPartnerChecklist || user['role'] == 'Guest') && user['type'] !== 'External') ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac df jcc aic`}>
										<svg className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path className="fa-primary" d="M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z" /><path className="fa-secondary" d="M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z" /></svg>
										Download PDF
									</button>
									{tab == "kpi-report" && isViewTwoMinuteReport &&
										<button onClick={() => twoMinuteTestAIReport(module)} style={{ padding: '6px 25px' }}
											className={`${(module?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`}>
											View 2-Minute Test Report
										</button>
									}
								</> || <>
										{getCompletenessAndRiskHTML("sidebar-" + tab, company.modules[sanitiseTab(tab)].stats)}
										{((company?.['subscription'] === 'Pro' && module['type'] === 'repository') || isTwoMinuteTesHomePage) &&
											<button onClick={() => toggleAllSectionsExpand()} className="pa r0 cp c6 tac lh1 fs2rem sideBarAllCollapse"
												style={{ top: '150px', transform: 'translate(-50%, -60%)', userSelect: 'none', }}>
												{allSectionsExpand ? <KeyboardArrowUp className="c51" /> : <KeyboardArrowDown className="c51" />}
											</button>
										}
									</>
								}
							</div>
						}
						<div className={`mah100 mya oya df fdc jcsb bbrr5px bblr5px ${module['type'].includes('business-audit') && "businessAuditSidebar"}`}>
							{(tab !== "kpi-report" && array.length > 0) && array.slice().sort(sortSections).map(section => {
								let sectionFiles = getFilesFromQuestions(section?.questions);
								// TODO: Calculate Stats for Expansion Packs
								if (!section.stats) section.stats = module['sections'][0]['stats'];
								let completeness;
								if (isWorkflowReport && section?.stats?.workflowCompletionPercent) completeness = section.stats.workflowCompletionPercent;
								else if (module['type'] == 'repository' && company['subscription'] == 'Lite') {
									if (section.questions) completeness = section.questions.filter(q => q.qNo == section.sectionNo)[0]?.['answer']?.['status'] == 'Completed' ? 100 : 0;
								}
								else completeness = section.stats.completionPercent ?? 0;
								let riskColour;
								if ((module['type'] === "repository" || module['type'] === "investor-lead") || section.stats.riskPercent < 38) riskColour = 7;
								else if (section.stats.riskPercent > 62) riskColour = 9;
								else riskColour = 8;

								let hexColour;
								if (isWorkflowReport && section?.stats?.workflowCompletionPercent) hexColour = section?.stats?.workflowCompletionPercent > 75 ? '#d8fcc7' : section?.stats?.workflowCompletionPercent > 26 ? '#fff4c9' : section?.stats?.workflowCompletionPercent > 1 ? '#ffcecc' : '#dbdbdb';
								else hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";

								let tooltip;
								if (isWorkflowReport) {
									if (completeness) tooltip = ReactDOMServer.renderToStaticMarkup(<p className="tac maw200px">{`This section has ${completeness}% workflow completeness`}</p>);
								}
								else tooltip = ReactDOMServer.renderToStaticMarkup(<p className="tac maw200px">
									{`This section is ${completeness}% complete` + ((module['type'] !== "repository" || module['type'] !== "investor-lead") ?
										` ${section.stats.completionPercent === 0 ? module['type'] === "repository" ? "" : " with no risk score." :
											module['type'] === "repository" ? "" : `with a risk score of ${section?.stats?.riskPercent ? section?.stats?.riskPercent : '0'}%.`
										}` :
										"")}
								</p>);

								if (section['disabled']) tooltip = ReactDOMServer.renderToStaticMarkup(<p className="tac maw200px">{`Please request admin to access ${section['sectionNo']}`}</p>);

								let colorChange = false;
								if (module['type'] == "warranty-disclosure") {
									section?.questions.map(question => {
										if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
											colorChange = true;
											return;
										}
									})
								}

								let disabledSection = false;
								if ((module['type'] == 'repository' || module['type'] == `business-audit-${company['testType']}`) && (user['role'] == "Advisor" || user['role'] == "Investor" || user['role'] == 'Member') && (user?.['companyId'] && user?.['companyId']?.['_id'] != company?.['_id']) && (company['advisors'] || company['investors'] || company['memberPermissions'])) {
									// if (user['role'] == 'Advisor' && company?.['advisors']?.[user['_id']]?.['modules'] && !company?.['advisors']?.[user['_id']]?.['modules']?.[section['sectionNo']] && user?.['companyId']?.['_id'] !== company['_id']) disabledSection = true;
									if (user['role'] == 'Investor' && !company?.['investors']?.[user['_id']]?.['modules']?.[section['sectionNo']]) disabledSection = true;
									if (user['role'] == 'Member' && !company?.owners.includes(user['_id']) && !company?.['memberPermissions']?.[user['_id']]?.[section['sectionNo']]) disabledSection = true;
								}

								if (tab == 'Investment Readiness') {
									let answers = {};
									section?.questions && section?.questions.forEach(ques => {
										const qNo = ques['qNo'];
										answers[qNo] = {
											radioOption: ques?.['answer']?.['radioOption'], hasContent: ques?.['answer'] && (ques?.['answer']?.['files']?.length > 0 || ques?.['answer']?.['comment'])
										};
									});

									const isYesWithContent = (qNo) => { return answers[qNo]?.radioOption === 'Yes' && answers[qNo]?.hasContent };
									const isNoOrNA = (qNo) => { return answers[qNo]?.radioOption === 'No' || answers[qNo]?.radioOption === 'N/A' };

									// marketOpportunity (requires both 1.1 AND 1.2)
									if (section['sectionNo'] == `${module['moduleKey']}1`) {
										coreInfoResearchAid['marketOpportunity']['sectionNo'] = section['sectionNo'];

										const q11 = `${module['moduleKey']}1.1`;
										const q12 = `${module['moduleKey']}1.2`;

										if (isYesWithContent(q11) && isYesWithContent(q12)) {
											coreInfoResearchAid['marketOpportunity']['uploaded'] = true;
											coreInfoResearchAid['marketOpportunity']['notUploaded'] = false;
										} else if (isNoOrNA(q11) || isNoOrNA(q12)) {
											coreInfoResearchAid['marketOpportunity']['uploaded'] = false;
											coreInfoResearchAid['marketOpportunity']['notUploaded'] = true;
										} else {
											coreInfoResearchAid['marketOpportunity']['uploaded'] = false;
											coreInfoResearchAid['marketOpportunity']['notUploaded'] = false;
										}
									}

									// routeToMarket (requires only 1.1)
									if (section['sectionNo'] == `${module['moduleKey']}1`) {
										coreInfoResearchAid['routeToMarket']['sectionNo'] = section['sectionNo'];

										const q11 = `${module['moduleKey']}1.1`;

										if (isYesWithContent(q11)) {
											coreInfoResearchAid['routeToMarket']['uploaded'] = true;
											coreInfoResearchAid['routeToMarket']['notUploaded'] = false;
										} else if (isNoOrNA(q11)) {
											coreInfoResearchAid['routeToMarket']['uploaded'] = false;
											coreInfoResearchAid['routeToMarket']['notUploaded'] = true;
										} else {
											coreInfoResearchAid['routeToMarket']['uploaded'] = false;
											coreInfoResearchAid['routeToMarket']['notUploaded'] = false;
										}
									}

									// competitorAnalysis (requires both 5.1 AND 5.5)
									if (section['sectionNo'] == `${module['moduleKey']}5`) {
										coreInfoResearchAid['competitorAnalysis']['sectionNo'] = section['sectionNo'];

										const q51 = `${module['moduleKey']}5.1`;
										const q55 = `${module['moduleKey']}5.5`;

										if (isYesWithContent(q51) && isYesWithContent(q55)) {
											coreInfoResearchAid['competitorAnalysis']['uploaded'] = true;
											coreInfoResearchAid['competitorAnalysis']['notUploaded'] = false;
										} else if (isNoOrNA(q51) || isNoOrNA(q55)) {
											coreInfoResearchAid['competitorAnalysis']['uploaded'] = false;
											coreInfoResearchAid['competitorAnalysis']['notUploaded'] = true;
										} else {
											coreInfoResearchAid['competitorAnalysis']['uploaded'] = false;
											coreInfoResearchAid['competitorAnalysis']['notUploaded'] = false;
										}
									}

									// technologyAdvantage (requires both 4.1 AND 4.4)
									if (section['sectionNo'] == `${module['moduleKey']}4`) {
										coreInfoResearchAid['technologyAdvantage']['sectionNo'] = section['sectionNo'];

										const q41 = `${module['moduleKey']}4.1`;
										const q44 = `${module['moduleKey']}4.4`;

										if (isYesWithContent(q41) && isYesWithContent(q44)) {
											coreInfoResearchAid['technologyAdvantage']['uploaded'] = true;
											coreInfoResearchAid['technologyAdvantage']['notUploaded'] = false;
										} else if (isNoOrNA(q41) || isNoOrNA(q44)) {
											coreInfoResearchAid['technologyAdvantage']['uploaded'] = false;
											coreInfoResearchAid['technologyAdvantage']['notUploaded'] = true;
										} else {
											coreInfoResearchAid['technologyAdvantage']['uploaded'] = false;
											coreInfoResearchAid['technologyAdvantage']['notUploaded'] = false;
										}
									}
								}

								const lastUpdateSection = getSectionUpdatedAt(company, section);

								return <>
									{((['repository', 'warranty-disclosure', 'software-development', 'esg', 'directors-questionnaire'].includes(module?.['type'])) || isTwoMinuteTesHomePage)
										? <>
											<button
												disabled={section['disabled'] || disabledSection}
												data-tooltip={!section['isDisabled'] ? tooltip : ''}
												className={`c3-hover c51 bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`}
												style={{ background: (section['disabled'] || disabledSection) ? 'transparent' : `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` }}
												onClick={() => handleScroll(section['sectionNo'])}>
												{tab.endsWith("-report") && !isExternalPage &&
													<span className={`asc checkbox w30px h30px pr mr1rem ${(section['disabled'] || section['isDisabled'] || disabledSection) ? 'op40' : 'op100 c3-hover'}`}>
														<input onChange={() => { section['isHidden'] = !section['isHidden']; dispatch(setCompany({ ...company })) }} checked={!section['isHidden']} type="checkbox" className="bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px" />
													</span>}
												<div data-tooltip={!section['isDisabled'] ? tooltip : ''} onClick={() => handleScroll(section['sectionNo'])} className="df fww w100">
													<span className={`${showInTooltip ? 'fs0-5rem ' : 'fs0-75rem'} ${(section['disabled'] || section['isDisabled'] || disabledSection) ? 'op40' : 'op100 c3-hover'} sidemenu fw500 asc pen uss ass tal pr1rem`}>{section['sectionName']}</span>
													{((company?.['subscription'] === 'Pro' || isTwoMinuteTesHomePage) && !allSectionsExpand && section?.subFolders) && <button
														disabled={(section['disabled'] || disabledSection)}
														className={`c3-hover expand-button cp`}
														onClick={() => toggleSectionExpand(section['_id'])}>
														{(section['disabled'] || section['isDisabled'] || disabledSection) ? <LockOutlined
															className="op40"
															style={{ fontSize: "18px", fontWeight: 300 }}
														/> : sectionExpand[section['_id']] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
													</button>}
													{(!isTwoMinuteTesHomePage && lastUpdateSection) &&
														<div
															className={`w100 df jcc tac mt0-5rem cp c6-hover ${(section['disabled'] || disabledSection) ? 'c12 c12-hover' : 'c2'}`}
															style={{ fontSize: "10px" }}>Last Updated: {moment(lastUpdateSection).format('DD/MMM/YY')}
														</div>
													}
													{sectionFiles && sectionFiles.length > 0 &&
														<button
															className="pa r0 cp bg44 df jcc"
															onClick={() => {
																setSection(section);
																setFolderNo(section?.sectionNo);
																setFolderFiles(sectionFiles);
																setFolderName(section?.sectionName);
																dispatch(toggleModal({ open: 'manageIndexFiles' }));
															}}>
															<FolderIcon className={`pa r0 fs2rem w20 h20 t50 c7 ${sectionFiles.length > 0 ? 'c10' : 'c12'}`} />
															<div className="pa qNoSidebar c1 fs0-5rem fw600" style={{ top: '8px', userSelect: 'none', }}>
																{sectionFiles.length > 0 && sectionFiles.length}
															</div>
														</button>
													}
												</div>
											</button>
											{(sectionExpand[section['_id']] || allSectionsExpand) && (
												<div className="sub-folders cp">
													{/* subFolder */}
													{section?.subFolders && Object.keys(section?.subFolders).map(subFolder => {
														return <>
															{showSection(section, sectionFiles, section?.subFolders[subFolder])}
															{/* subSubFolder */}
															{section?.subFolders[subFolder]?.subFolders &&
																Object.keys(section?.subFolders[subFolder]?.subFolders).map(subSubFolder => {
																	return (<>
																		{showSection(section, sectionFiles, section?.subFolders[subFolder]?.subFolders[subSubFolder])}
																		{/* subSubSubFolder */}
																		{section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders &&
																			Object.keys(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders).map(subSubSubFolder => {
																				return (<>
																					{/* {showSection(section, sectionFiles, section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder])} */}
																					{isTwoMinuteTesHomePage ? (
																						<button className="df fww w100"
																							style={{ width: '96%', padding: '5px 0px 0px 7px', cursor: 'not-allowed' }}
																							disabled
																						>
																							<span className={"w70 asc pen uss ass tal pr1-5rem pl1rem"}>
																								{section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no} {section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name}
																							</span>
																						</button>
																					) : (
																						<div onClick={() => handleScroll(section['sectionNo'])} className="df fww w100" style={{ width: '92%', padding: '5px 0px 0px 15px', background: section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.stats?.completionPercent > 0 ? '#bbeadb' : 'transparent' }}>
																							<span className={"w70 asc pen uss ass tal pr1-5rem pl1rem c2 c6-hover"}>
																								{section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no} {section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name}
																							</span>
																							{sectionFiles && sectionFiles.filter(file => file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length > 0 &&
																								<button className="pa r0 cp mr0-5rem" style={{ background: "transparent" }}
																									onClick={() => {
																										setSection(section);
																										setFolderNo(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no);
																										setFolderName(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name);
																										setFolderFiles(sectionFiles && sectionFiles.filter(file => file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no));
																										dispatch(toggleModal({ open: 'manageIndexFiles' }));
																									}}>
																									<FolderIcon className={`pa r0 fs2rem w10 h10 t50 ${sectionFiles.filter(file => file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length > 0 ? 'c10' : 'c12'}`} />
																									<div
																										className="pa qNoSidebar c1 fs0-5rem fw600"
																										style={{ top: '8px', userSelect: 'none', }}
																									>
																										{sectionFiles && sectionFiles.filter(file => file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length > 0 &&
																											sectionFiles.filter(file => file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length
																										}
																									</div>
																								</button>
																							}
																						</div>
																					)}
																				</>)
																			})}
																	</>
																	)
																})
															}
														</>
													})
													}
												</div >
											)}
										</>
										: <button onClick={() => { setActivePoint(section['sectionNo']); handleScroll(section['sectionNo']) }} disabled={disabledSection} data-tooltip={tooltip} className={`${disabledSection ? 'c12' : 'c2 c3-hover'} bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`}
											style={{ background: isWorkflowReport ? `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` : disabledSection ? 'transparent' : `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` }}>
											{tab.endsWith("-report") &&
												<span className="asc checkbox w30px h30px pr mr1rem">
													<input onChange={e => { section['isHidden'] = !section['isHidden']; dispatch(setCompany({ ...company })) }} className="bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px" type="checkbox" checked={!section['isHidden']} />
												</span>
											}
											<span className={(showInTooltip ? 'fs0-5rem ' : 'fs0-75rem ') + "fw500 asc pen uss ass tal"}>{section['sectionName']} </span>
										</button>
									}
								</>
							})}
						</div>
						{tab === "repository" && company.subscription == "Pro" &&
							<div className="hf df aic jcc mt1 mb4">
								<div className="additional-sections-button">
									<button
										onClick={() => dispatch(toggleModal({ open: 'proaddsection' }))}
										className="btn-packge shadow bg3 bg4-hover c1 td250 br50px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic fs0-75rem"
									>
										Add/Edit User Defined Sections
										<span className="tooltip-area" style={{ color: 'black', left: '-8px', right: 'auto' }}>
											<i className="icon">
												<img className="h4rem" src={require(`../../../../images/info-icon.svg`)} alt="" />
												<div className="overlay-box">
													<p>Diligentsia Pro allows users to add up to 5 user-defined sections to the Data Repository Index structure.  These are then replicated in your Data Room (Drive/Sharepoint/Dropbox )</p>
												</div>
											</i>
										</span>
									</button>
								</div>
							</div>
						}
					</div>
				}
				{(user['role'] == 'Guest' && localStorage.getItem('isPartnerChecklist')) &&
					<div className="w100 df fdc aic">
						<button onClick={() => handlePartnerChecklistNext(module)} className={`w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem mt1rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
							Next
						</button>
						<Link to={module?.['stats']['completionPercent'] > 0 && "/register"} className={`w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem mt0-5rem df aic jcc ${module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
							Save for later
						</Link>
						{!tab.endsWith("-report") && <img className="df w100 mb1rem" src={require(`../../../../images/partner-checklist/partner-flow-ai-help.png`)} alt="" />}
						{tab.endsWith("-report") && <img className="df w100 mb1rem" src={require(`../../../../images/partner-checklist/sidebar-partner-checklist-ai.png`)} alt="" />}
					</div>
				}
				{(user['type'] == 'Superflow' && tab == `investor-lead`) && <>
					<div class='df fdc aic mt1rem'>
						<img className="df w100 mb1rem" src={require(`../../../../images/super-flow/investor-lead-ai.png`)} alt="" />
						<button onClick={() => handleSuperflowNext()} data-tooltip={company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] != 100 ? 'Please complete the module 100%' : ''}
							className={`w50 shadow fw500 fs0-75rem br50px px1rem py0-5rem df aic jcc ${company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100 ? 'bg4 cp c1' : 'bg16 cna c14'} `}>
							Next
						</button>
					</div>
				</>
				}
				{(tab == 'Investment Readiness') &&
					<div class='superflow-section mah40 oscy'>
						<div class='bo45 bss bw1px br10px bg1 p0-5rem mt0-5rem'>
							<p class='c14 fs1rem lh2 tac'>Core Information For <br /> ResearchAid Reports</p>
							{Object.values(coreInfoResearchAid).map(item => {
								return <button onClick={() => { setActivePoint(item['sectionNo']); handleScroll(item['sectionNo']) }}
									class='cp w100 df bo45 bss bw1px br20px bg1 p0-5rem mt0-5rem' style={{ backgroundColor: item['uploaded'] ? '#deffe9' : item['notUploaded'] ? '#ffdddd' : '#ffffff' }}>
									<div class='w10 mr0-5rem'>
										{item['uploaded'] && <img className="w20px h20px" src={require(`../../../../images/super-flow/sidebar-check-icon.png`)} alt="check-icon" />}
										{item['notUploaded'] && <img className="w20px h20px" src={require(`../../../../images/super-flow/sidebar-cross-icon.png`)} alt="cross-icon" />}
									</div>
									<div class='w80 df fdc mx0-5rem'>
										<p class='w100 fs0-75rem c14 lh1'>{item['name']} <span class='c4'>*</span></p>
										<p class='w100 fs0-75rem c12 lh2'>({item['path']})</p>
									</div>
									<div class='w10 ml0-5rem'><img className="w20px h20px" src={require(`../../../../images/super-flow/sidebar-file-icon.png`)} alt="file-icon" /></div>
								</button>
							})}
						</div>
						<div class='df fdc aic mt1rem'>
							<img className="df w100 mb1rem" src={require(`../../../../images/super-flow/investment-readiness-ai.png`)} alt="" />
						</div>
						{user['type'] == 'Superflow'
							? <>
								<div className="w100 df fdc aic mb2rem">
									<button onClick={() => handleCompleteInvestmentReadiness()} className={`w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
										Next
									</button>
									<button onClick={() => updateUserType()} className={`w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
										Save for later
									</button>
								</div>
							</>
							: <div className="w100 df fdc aic mb2rem">
								<button onClick={() => handleCompleteInvestmentReadiness()} className={`w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
									Generate
								</button>
							</div>
						}
					</div>
				}
				{(user?.['type'] == 'Superflow' && tab == 'Investment Readiness-report') &&
					<div class='df fdc aic mt1rem'>
						<img className="df w100 mb1rem" src={require(`../../../../images/super-flow/report-sidebar-ai.png`)} alt="" />
						<button onClick={() => module?.['stats']['completionPercent'] > 0 && dispatch(toggleModal({ open: 'superFlowCompletedPopup' }))} className={`w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem my1rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
							Next
						</button>
					</div>
				}
				{tab.match(/two-minute-test-.*-report/) && user?.role.toLowerCase() === "guest"
					? <>
						<img src={require("../../../../images/2minutesTestSidebarDiligentsia.png")} alt="2minutesTestSidebarDiligentsia" />
						<a href={`/company/${company['_id']}`} style={{ width: '75%', paddingTop: '12px', paddingBottom: '12px', marginLeft: "auto", marginRight: "auto" }} className={`shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`}>
							Next
						</a>
					</>
					: (!localStorage.getItem('isDemoChecklist') || !localStorage.getItem('isPartneChecklist')) && <>
						{shouldShowBusinessCard({ company }) && <>
							{company?.isParent
								? (tab !== 'investor-lead' && tab !== 'kpi-report') && <IndirectCompanyUserAdCard
									onCardLog={onCardLog}
									user={user}
									LiButton={LiButton}
									company={company}
									truncateText={truncateText}
									activePoint={activePoint}
									visibleSection={visibleSection}
									getCompanyById={getCompanyById}
									allocatedAdvisor={allocatedAdvisor?.email ? allocatedAdvisor : { ...user, sectionName: getSectionName(company, visibleSection) }}
								/>
								: <UserAdCard
									onCardLog={onCardLog}
									user={user}
									LiButton={LiButton}
									company={company}
									truncateText={truncateText}
									getSectionName={getSectionName}
									activePoint={activePoint}
									visibleSection={visibleSection}
									getCompanyById={getCompanyById}
								/>
							}
						</>
						}
						{shouldRenderReferOffer ? <ReferOffer /> : null}
						{showReferCard({ company, user }) ? <CompanyReferOffer company={company} /> : null}
					</>
				}
				{(user['role'] == 'Guest' && tab == `two-minute-test-${company['testType']}`) &&
					<div class='df fdc aic mt1rem'>
						<img className="df w100 mb1rem" src={require(`../../../../images/two-minute-test-ai.png`)} alt="" />
					</div>
				}
			</div>
		)
		return showInTooltip ? ReactDOMServer.renderToStaticMarkup(jsx) : jsx;
	};

	const convertImageToBase64 = async (imgUrl) => {
		try {
			const response = await fetch(imgUrl);
			const blob = await response.blob();
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onloadend = () => resolve(reader.result);
				reader.onerror = reject;
				reader.readAsDataURL(blob);
			});
		} catch (error) {
			console.error('Error converting image to base64:', error);
			return imgUrl;
		}
	};

	const convertAllImagesToBase64 = async (element) => {
		const images = element.querySelectorAll('img');
		const imagePromises = [];
		for (const img of images) {
			const src = img.src;
			// Check if the image is from S3 or other external sources
			if (src && (src.includes('s3') || src.includes('amazonaws') || src.includes('cloudfront'))) {
				imagePromises.push(convertImageToBase64(src).then(base64 => {
					img.setAttribute('data-original-src', src);
					img.src = base64;
				}));
			}
		}
		await Promise.all(imagePromises);
	};

	const restoreOriginalImages = (element) => {
		const images = element.querySelectorAll('img[data-original-src]');
		for (const img of images) {
			img.src = img.getAttribute('data-original-src');
			img.removeAttribute('data-original-src');
		}
	};

	const downloadPDF = async () => {
		try {
			// If Papermill PDF exists (reportUrl), download from S3 directly
			const moduleName = sanitiseTab(tab);
			const currentModule = company?.modules?.[moduleName];
			if (currentModule?.reportUrl) {
				setIsLoader({ show: true, message: 'Downloading PDF...' });
				// Create a temporary link to trigger download
				const link = document.createElement('a');
				link.href = currentModule.reportUrl;
				link.target = '_blank';
				link.download = `${company.cName || 'Report'} - ${moduleName}.pdf`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				setIsLoader({ show: false, message: 'Loading...' });
				return;
			}

			setIsLoader({ show: true, message: 'PDF Downloading...' });
			const wrapper = document.getElementById("pdf");
			document.querySelectorAll(".oscy").forEach(el => el.classList.remove("h60vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.remove("mah40vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.add("mah100vh"));
			wrapper.classList.remove("gg2rem");

			let tempWrapper = wrapper;
			for (const hideEl of tempWrapper.querySelectorAll(".hideOnDownload")) hideEl.classList.add("op0");
			// Convert S3 images to base64 before generating PDF
			await convertAllImagesToBase64(tempWrapper);
			const filename = [company.cName, company.subscription, tab].join(" - ");

			// Generate PDF page by page to avoid page break issues
			const pages = tempWrapper.querySelectorAll('.a4-pdf');
			const pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
			const pdfWidth = 210;
			const pdfHeight = 297;

			for (let i = 0; i < pages.length; i++) {
				const page = pages[i];
				const canvas = await html2canvas(page, {
					useCORS: true,
					allowTaint: true,
					logging: false,
					scale: 2,
					backgroundColor: '#ffffff'
				});

				const imgData = canvas.toDataURL('image/jpeg', 1.0);
				if (i > 0) pdf.addPage();
				pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
			}

			pdf.save(filename + '.pdf');

			// Restore original image URLs after PDF generation
			restoreOriginalImages(tempWrapper);

			wrapper.classList.add("gg2rem");
			for (const page of wrapper.children)
				page.classList.add("shadow");
			for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))
				hideEl.classList.remove("op0");
			document.querySelectorAll(".oscy").forEach(el => el.classList.add("h60vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.add("mah40vh"));
			document.querySelectorAll(".tableRow").forEach(el => el.classList.remove("mah100vh"));
			setIsLoader({ show: false, message: 'Loading...' });
		} catch (e) {
			console.error(e);
			setIsLoader({ show: false, message: 'Loading...' });
		}
	};

	const getFileHTML = (file) => {
		let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${AppMode === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
		const key = file.key;

		return <>
			<div className="df jcfs aic w100 px1rem py0-5rem td250 bsbb">
				{["pdf"].includes(file.ext) && <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z" /><path className="fa-secondary" d="M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z" /></svg>
					|| ["mp4", "webm", "mkv", "ogg", "avi", "mov"].includes(file.ext) && <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M256 0v128h128L256 0zM192 256H96C78.33 256 64 270.3 64 288v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288C224 270.3 209.7 256 192 256zM295.5 271.3L256 296v80l39.52 24.7C306.2 407.4 320 399.7 320 387.1V284.9C320 272.3 306.2 264.6 295.5 271.3z" /><path className="fa-secondary" d="M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM224 384c0 17.67-14.33 32-32 32H96c-17.67 0-32-14.33-32-32V288c0-17.67 14.33-32 32-32h96c17.67 0 32 14.33 32 32V384zM320 387.1c0 12.57-13.82 20.23-24.48 13.57L256 376v-80l39.52-24.7C306.2 264.6 320 272.3 320 284.9V387.1z" /></svg>
					|| ["sheet", "xlsx", "xls", "xlsm", "ots", "csv"].includes(file.ext) && <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M256 0v128h128L256 0zM312 224h-240c-8.875 0-16 7.125-16 16v192c0 8.875 7.125 16 16 16h240c8.875 0 16-7.125 16-16v-192C328 231.1 320.9 224 312 224zM136 416h-48v-48h48V416zM136 336h-48V288h48V336zM216 416h-48v-48h48V416zM216 336h-48V288h48V336zM296 416h-48v-48h48V416zM296 336h-48V288h48V336z" /><path className="fa-secondary" d="M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM328 432c0 8.875-7.125 16-16 16h-240c-8.875 0-16-7.125-16-16v-192c0-8.875 7.125-16 16-16h240c8.875 0 16 7.125 16 16V432z" /></svg>
					|| ["png", "jpg", "jpeg", "gif", "bmp", "svg", "webp"].includes(file.ext) && <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M256 0v128h128L256 0zM231.1 295.1C229 290.7 224 288 218.7 288s-10.35 2.674-13.31 7.125L160 363.2l-13.35-20.03C143.7 338.7 138.7 336 133.3 336s-10.35 2.674-13.31 7.125l-53.33 80c-3.273 4.908-3.578 11.22-.7949 16.42C68.68 444.8 74.1 448 80 448h224c5.9 0 11.32-3.248 14.11-8.451c2.783-5.201 2.479-11.52-.7949-16.42L231.1 295.1z" /><path className="fa-secondary" d="M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 224c17.67 0 32 14.33 32 32S113.7 288 96 288S64 273.7 64 256S78.33 224 96 224zM318.1 439.5C315.3 444.8 309.9 448 304 448h-224c-5.9 0-11.32-3.248-14.11-8.451c-2.783-5.201-2.479-11.52 .7949-16.42l53.33-80C122.1 338.7 127.1 336 133.3 336s10.35 2.674 13.31 7.125L160 363.2l45.35-68.03C208.3 290.7 213.3 288 218.7 288s10.35 2.674 13.31 7.125l85.33 128C320.6 428 320.9 434.3 318.1 439.5z" /></svg>
					|| ["zip", "7z", "gz", "tar.gz"].includes(file.ext) && <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M160 32H96v32h64V32zM160 160H96v32h64V160zM160 96H96v32h64V96zM256 0v128h128L256 0zM160 224H96l-30.56 116.5c-7.93 39 22.26 75.45 62.83 75.45c40.26 0 70.45-36.3 62.68-75.15L160 224zM144 368h-32C103.2 368 96 360.8 96 352s7.164-16 16-16h32C152.8 336 160 343.2 160 352S152.8 368 144 368z" /><path className="fa-secondary" d="M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 32h64v32H96V32zM96 96h64v32H96V96zM96 160h64v32H96V160zM128.3 415.1c-40.56 0-70.76-36.45-62.83-75.45L96 224h64l30.94 116.9C198.7 379.7 168.5 415.1 128.3 415.1z" /></svg>
					|| ["doc", "docx", "docm", "rtf", "odt", "dot", "dotx"].includes(file.ext) && <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M256 0v128h128L256 0zM304.9 240h-23.37c-5.588 0-10.44 3.859-11.69 9.301L246.2 352L218.4 248.9C216.1 243.6 212.2 240 206.8 240H177.2c-5.426 0-10.18 3.641-11.59 8.883L137.8 352L114.1 249.3C112.9 243.9 108 240 102.5 240H79.08c-7.717 0-13.43 7.18-11.69 14.7l42.46 184C111.1 444.1 115.1 448 121.5 448h29.26c5.428 0 10.18-3.641 11.59-8.883L192 329.1l29.61 109.1C223 444.4 227.8 448 233.2 448h29.26c5.588 0 10.44-3.859 11.69-9.305l42.46-184C318.3 247.2 312.6 240 304.9 240z" /><path className="fa-secondary" d="M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM274.1 438.7C272.9 444.1 268 448 262.5 448h-29.26c-5.426 0-10.18-3.641-11.59-8.883L192 329.1l-29.61 109.1C160.1 444.4 156.2 448 150.8 448H121.5c-5.588 0-10.44-3.859-11.69-9.305l-42.46-184C65.66 247.2 71.37 240 79.08 240h23.37c5.588 0 10.44 3.859 11.69 9.301L137.8 352L165.6 248.9C167 243.6 171.8 240 177.2 240h29.61c5.426 0 10.18 3.641 11.59 8.883L246.2 352l23.7-102.7C271.1 243.9 275.1 240 281.5 240h23.37c7.717 0 13.43 7.18 11.69 14.7L274.1 438.7z" /></svg>
					|| ["pptx", "pttm", "ppt"].includes(file.ext) && <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M199.5 240H128C119.2 240 112 247.2 112 256v176C112 440.8 119.2 448 128 448h16C152.8 448 160 440.8 160 432v-40h44c44.53 0 80.23-38.49 75.59-83.95C275.6 268.5 239.3 240 199.5 240zM204 344H160V288h44c15.44 0 28 12.56 28 28S219.4 344 204 344zM256 0v128h128L256 0z" /><path className="fa-secondary" d="M204 288H160v56h44c15.44 0 28-12.56 28-28S219.4 288 204 288zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM204 392H160v40C160 440.8 152.8 448 144 448H128c-8.836 0-16-7.164-16-16V256c0-8.836 7.164-16 16-16h71.51c39.75 0 76.05 28.52 80.08 68.05C284.2 353.5 248.5 392 204 392z" /></svg>
					|| <svg className="f3 h2rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path className="fa-primary" d="M256 0v128h128L256 0zM272 384h-160C103.2 384 96 391.2 96 400S103.2 416 112 416h160c8.836 0 16-7.164 16-16S280.8 384 272 384zM272 320h-160C103.2 320 96 327.2 96 336S103.2 352 112 352h160c8.836 0 16-7.164 16-16S280.8 320 272 320zM272 256h-160C103.2 256 96 263.2 96 272S103.2 288 112 288h160C280.8 288 288 280.8 288 272S280.8 256 272 256z" /><path className="fa-secondary" d="M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM272 416h-160C103.2 416 96 408.8 96 400S103.2 384 112 384h160c8.836 0 16 7.164 16 16S280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336S103.2 320 112 320h160c8.836 0 16 7.164 16 16S280.8 352 272 352zM272 288h-160C103.2 288 96 280.8 96 272S103.2 256 112 256h160C280.8 256 288 263.2 288 272S280.8 288 272 288z" /></svg>}
				<div onClick={() => getViewableURL(file.url)} rel="noopener noreferrer" style={{ flex: 1 }} className={`mx1rem fs1rem cp fw600 bg1 ${fileColor}`}>{file.title}</div>
				<Link target="_blank" to={file.url}>
					<svg data-tooltip={"Download"} className={`f3 h1rem cp mr1rem ${tab == 'repository' ? '' : 'mla'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
						<path className="fa-primary" d="M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z" /><path className="fa-secondary" d="M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z" />
					</svg>
				</Link>
			</div>
		</>
	};

	const handleRedirectDashboard = async () => {
		let res = await postRequest('/user/updateUserType', { type: 'User' });
		if (res['code'] == '200') {
			await getUser();
			setTabName('');
			setOpenTabs(new Set());
			navigate(`/company/${company['_id']}`);
		}
	};

	const userRoleLower = typeof user?.role === 'string' ? user.role.toLowerCase() : '';
	const createdByRoleLower = typeof user?.createdBy?.role === 'string' ? user.createdBy.role.toLowerCase() : '';
	const userEmailHasCfoDomain = typeof user?.email === 'string' && user.email.includes('@cfocentre.com');
	const companyHasCfoAdvisor = Array.isArray(company?.advisorData) && company.advisorData.some(advisor => typeof advisor?.email === 'string' && advisor.email.includes('@cfocentre.com'));
	const createdByRole = company?.creatorId?.createdBy?.role?.toLowerCase();
	const isCreatedByAdvisorOrInvestor = !createdByRole || ['investor', 'advisor'].includes(createdByRole);
	const shouldRenderReferOffer = (((userEmailHasCfoDomain && userRoleLower === 'advisor') || companyHasCfoAdvisor || userRoleLower === 'advisor' || createdByRoleLower === 'advisor') && !isCreatedByAdvisorOrInvestor);

	return (
		<>
			{getSidebarHTML(company.modules[sanitiseTab(tab)])}

			{/* Complete Manage Files */}
			<Modal open={modal['open'] == 'manageIndexFiles'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw800px br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h2 className="text-gradient fw600 tac mb1rem fs1-25em">{company.cName}<br />Section File Manager</h2>
					<h2 className="c4 fs1-25rem-sm ttu w100 tac mb2rem">{`${folderNo} ${folderName}`}</h2>
					<div className="dg gg1rem mb2rem fs1rem">
						{folderFiles && folderFiles.length > 0 && folderFiles.map((file) => { return getFileHTML(file) })
							|| <span className="fs1-25rem fw500 gcs1 gce5-md tac">No files have been added yet</span>}
					</div>
				</div>
			</Modal>

			{/* Complete Investment Readiness */}
			<Modal id="completeInvestmentReadiness" open={modal['open'] == 'completeInvestmentReadiness'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className='df jcc oscy' style={{ maxHeight: '100vh' }}>
					<div className='mah90 oya bg1 shadow w800px p3rem bsbb df fdc aic m1rem br20px pr'>
						<img className='df my2rem' src={require('../../../../images/super-flow/complete-icon-popup.png')} alt='' />
						<p class='c15 fs1-25rem fw400 tac mb1rem'>Thank you for completing your Investment Readiness <br /> assessment.</p>
						<p class='c15 fs1rem fw400 tac mb3rem'>We are creating your ResearchAid Reports now. It will be ready in few minutes meantime you can view your Investment Readiness Report.</p>
						<div className='tac w100 db'>
							<Link onClick={(e) => handleReport(e, company?.['modules']?.[sanitiseTab(tab)])} to={`#${tab}-report`} className='cp w300px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250'>View Report</Link>
						</div>
					</div>
				</div>
			</Modal>

			{/* Super Flow Completed */}
			<Modal id="superFlowCompletedPopup" open={modal['open'] == 'superFlowCompletedPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className='df jcc oscy' style={{ maxHeight: '100vh' }}>
					<div className='mah90 oya bg5 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr'>
						<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
							<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
								<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
							</svg>
						</button>
						<img className='w20' src={require('../../../../images/super-flow/complete-logo-popup.png')} alt='' />
						<p class='c15 fs1-5rem fw500 mb3rem'>Congratulations. You now have access to the following reports</p>
						<div class='df jcc'>
							<img className='w110 mr0-5rem' src={require(`../../../../images/super-flow/step-1-popup.png`)} alt='step-1' />
							<img className='w110 mr0-5rem' src={require(`../../../../images/super-flow/step-2-popup.png`)} alt='step-2' />
							<img className='w110 mr0-5rem' src={require(`../../../../images/super-flow/step-3-popup.png`)} alt='step-3' />
							<img className='w110 mr0-5rem' src={require(`../../../../images/super-flow/step-4-popup.png`)} alt='step-4' />
						</div>
						<div className='tac w100 db mt1rem'>
							<button onClick={() => handleRedirectDashboard()} className='cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250'>Let's Go!</button>
						</div>
					</div>
				</div>
			</Modal>

			{/* Not Generated ResearchAid Reports Popup */}
			<Modal id="notGeneratedResearchAidReports" open={modal['open'] == 'notGeneratedResearchAidReports'} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore">
				<div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '750px' }}>
					<div className='top-logo pa t0 r0 mr1rem mt1rem'><img className='w4rem' src={require('../../../../images/favicon.png')} alt="" /></div>
					<div className='creaing-modal pr my1rem'>
						<h2 className='fs1-25rem fw600 c4 my2rem mb2rem tac'>ResearchAid Reports Not Generated!</h2>
						<div className='df jcc'><img className="w10rem" src={require('../../../../images/400-error.png')} alt="" /></div>
						<div className='text-box w90 df jcc tac fdc mxa'>
							<p className='fs1rem fw400 c15 mt3rem mb1rem'>
								We are sorry due to some technical issues ResearchAid Reports are not generated automatically!
								<br />
								You can go to <b>Dashboard</b> and generate them manually.
							</p>
							<div className='tac w100 db'>
								<button onClick={() => window.location.href = `/company/${company['_id']}`} className='cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250'>Dashboard</button>
							</div>
						</div>
					</div>
				</div>
			</Modal>

			<ReferCfoOfferModal />
			<CompanyReferCfoOfferModal />
		</>
	);
}